/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Date_EndInputs */

const en_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Date End`)
};

const fr_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin de période personnalisée`)
};

const de_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefiniertes Enddatum`)
};

const it_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di fine personalizzata`)
};

const ru_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательская дата окончания`)
};

const es_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de finalización personalizada`)
};

const zh_cn2_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义日期结束`)
};

const ja_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム日付終了`)
};

const hi_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम दिनांक समाप्ति`)
};

const pt_pt2_custom_date_end = /** @type {(inputs: Custom_Date_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de término personalizada`)
};

/**
* | output |
* | --- |
* | "Custom Date End" |
*
* @param {Custom_Date_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_date_end = /** @type {((inputs?: Custom_Date_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Date_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_custom_date_end(inputs)
	if (locale === "de") return de_custom_date_end(inputs)
	if (locale === "it") return it_custom_date_end(inputs)
	if (locale === "ru") return ru_custom_date_end(inputs)
	if (locale === "es") return es_custom_date_end(inputs)
	if (locale === "zh-CN") return zh_cn2_custom_date_end(inputs)
	if (locale === "ja") return ja_custom_date_end(inputs)
	if (locale === "hi") return hi_custom_date_end(inputs)
	if (locale === "pt-PT") return pt_pt2_custom_date_end(inputs)
	return en_custom_date_end(inputs)
});